module.exports = require("core-js-pure/features/array/from");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/array/from.js
// module id = 516
// module chunks = 0 1